export default __webpack_public_path__ + "static/warehouse-dark-36494e14ec434f26e1437fa5e11dc717.png";